import { axiosInstance, axiosInstanceWithToken } from "@/utils/axios";
import { BASE_URL, HOST_API_KEY } from "../../config";

export const getAllNotificationsByUserId = async (userId) => {
  const response = await axiosInstanceWithToken.get(
    `${HOST_API_KEY}/notification/user/${userId}`
  );
  return response?.data;
};

export const getUnreadNotificationCountByUserId = async (userId) => {
  const response = await axiosInstanceWithToken.get(
    `${HOST_API_KEY}/notification/user/unread-count/${userId}`
  );
  return response?.data;
};

export const updateNotificationAsRead = async (notifId) => {
  const response = await axiosInstanceWithToken.put(
    `${HOST_API_KEY}/notification/read/${notifId}`
  );
  return response?.data;
};
